exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bv-modal-lineTwo p {\r\n    margin-bottom: 10px;\n}\r\n\r\n", ""]);

// exports
